export async function validateHuntPin({ token, lobby_pin }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/validateHuntPin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ lobby_pin }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.message || "Failed to validate lobby pin");
  if (data && data.success === false) throw new Error(data.message || "Failed to validate lobby pin");
  return data;
}
